import React from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { Modal } from '../ModalDialog';
var SCREEN = 'linkCreateEditScreen';
export var EditModal = function EditModal(_ref) {
  var _activePlugin$editVie;
  var onClose = _ref.onClose,
    onCloseComplete = _ref.onCloseComplete,
    editViewPayload = _ref.editViewPayload,
    activePlugin = _ref.activePlugin;
  return /*#__PURE__*/React.createElement(ModalTransition, null, !!editViewPayload && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    testId: "link-create-edit-modal",
    screen: SCREEN,
    onClose: onClose,
    shouldScrollInViewport: true,
    width: "calc(100vw - 120px)",
    height: "calc(100vh - 120px)",
    onCloseComplete: onCloseComplete
  }, activePlugin === null || activePlugin === void 0 || (_activePlugin$editVie = activePlugin.editView) === null || _activePlugin$editVie === void 0 ? void 0 : _activePlugin$editVie.call(activePlugin, {
    payload: editViewPayload,
    onClose: onClose
  }))));
};